<template>
  <div class="video_list">
    <div class="video_content">
      <!--视频播放-->
      <div class="video_boxs">
        <div class="video_play">
          <div class="video_box" style="position: relative;top: 0px;width: 100%;display: flex;justify-content: center;" id="videoBox">
          </div>
        </div>
      </div>
      <!--录像查询-->
      <div class="equipment">
        <div class="playback">
          <div></div>
          <div  style="font-size: 18px;color: #ffffff;margin: 0px 0px 0px;">回放控制</div>
          <div class="search">
            <div class="search_box">
              <div :class='["search_options_boxs"]' style="position: relative;left: 0px">
                <span>选择单位</span>
                <!--<img src="/static/img/select.png" alt="">-->
                <el-select
                  v-model="choiceDv"
                  style="margin-left: 20px;width: 50%"
                  placeholder="选择单位"
                  @change="getVideoId()">
                  <el-option
                    v-for="item in DvData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="search_box">
              <div :class='["search_options_boxs"]' style="position: relative;left: 0px">
                <span>选择设备</span>
                <!--<img src="/static/img/select.png" alt="">-->
                <el-select
                  v-model="valueID"
                  style="margin-left: 20px;width: 50%"
                  placeholder="请选择设备">
                  <el-option
                    v-for="item in IdData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="search_box">
              <span style="width: 100px;color: #ffffff;margin-left: 10px;width: 95px">设备ID</span>
              <!--                  <img src="/static/img/select.png" alt="">-->
              <el-input
                id="date"
                placeholder="设备ID"
                v-model="valueID"
                :disabled="true"
                style="width: 48%">
              </el-input>
            </div>
            <div class="search_box">
              <span style="color: #ffffff;margin-left: 10px;width: 75px" class="choiceDate">选择日期</span>
              <el-date-picker
                v-model="choiceDate"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="margin-left: 20px;width: 48%">
              </el-date-picker>
            </div>
            <div class="search_box">
              <span style="color: #ffffff;padding-left: 10px;width: 85px">选择时间</span>
              <el-time-picker
                is-range
                v-model="choiceTime"
                format="HH:mm:ss"
                value-format="HH:mm:ss"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
                style="margin-left: 20px;">
              </el-time-picker>
            </div>
            <div class="search_box">
              <el-button :class='["search_btn","green","icon_btn","clearborder"]' @click="getVideo()"><span class="el-icon-search" style="position: relative;top: -10px;left: 10px"></span><span style="position: relative;top: -10px;">搜索</span></el-button>
            </div>
          </div>
        </div>
        <div class="equipment_title">查询结果</div>
        <div class="table_content">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            max-height="300px"
            :style="fontSize">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              label="设备编号"
              width="120">
              <template slot-scope="scope">{{ scope.row.num }}</template>
            </el-table-column>
            <el-table-column
              prop="start_time"
              label="开始时间"
              width="120">
            </el-table-column>
            <el-table-column
              prop="end_time"
              label="结束时间"
              show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </div>
        <div style="width: 100%;margin-left: 0px">
          <button :class='["search_btn","blue","icon_btn","clearborder"]' @click="selectVideo()">回放</button>
        </div>
        <div class="table_paging">
          <el-pagination
            background
            hide-on-single-page
            layout="prev, pager, next"
            @current-change="getPage"
            :current-page=nowPage
            :total=totalPage
            page-size="4"
            @next-click="nextClick"
            @prev-click="prevClick"
            style="margin-left: 3%;">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "video_list",
    data() {
      return {
        totalPage:'',
        valueID: '',
        fontSize: '5px',
        choiceDate: '',
        choiceTime: '',
        choiceDv: '',
        tableData: [],
        tableDataCopy: [],
        value1: [],
        value2: [],
        selectAllList: [],
        Selection: [],
        DvData: [],
        IdData: [],
        nowPage: 1,
        video_1: '',
        video_0: '',
      }
    },
    methods:{
      handleSelectionChange(val) {
        console.log(val)
        if(val.length == 1){
          this.video_0 = val[0].videoUrl
        }else{
          this.$refs.multipleTable.clearSelection();
          this.video_0 = ''
          this.$message({
            message: '请选择单个视频录像!',
            type: 'warning'
          });
        }
      },

      InitLeftMenu:function () {
        this.$emit('getMessage', '2','1');
      },

      getVideoId:function () {
        this.IdData = []
        var n = this.choiceDv
        var selectList = this.selectAllList[n].data
        for (let i=0;i<selectList.length;i++){
          let projectObj = {};
          projectObj.label = selectList[i].name;
          projectObj.value = selectList[i].num;
          this.IdData .push(projectObj);
        };
      },


      selectVideo:function () {
        this.video_1 = ''
        this.video_1 = this.video_0
        this.playerMove1()
        this.video_0 = ''
      },


      playerMove1:function(){
        var videoBoxWidth = $("#videoBox").width();
        var videoBoxHeight = $("#videoBox").height();
        var videoSource1 = '<video id="myPlayer1" class="video-js" controls playsInline webkit-playsinline autoplay=false width="'+videoBoxWidth+'px" height="'+videoBoxHeight+'px">' +
          '<source id="videoSource1" type="video/mp4" src="'+this.video_1+'">'+
          '</video>';
        $("#videoBox").html("");
        $("#videoBox").html(videoSource1);
        this.myPlayer1 = "";
        this.myPlayer1 = new EZuikit.EZUIPlayer('myPlayer1');
        //this.myPlayer1.play();
      },

      //下载视频
      downloadFile() {
        window.open(
          baseUrl + '/xxx/xxx/xxx/getTemplate?templateCode=manual_pc',
          '_self'
        );
      },


      //获取单位与设备
      getSelectAll:function (){
        fetch("/api/v1/camera/Index", {
          method: 'post',
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            if (data.code == "200") {
              this.message = "数据获取成功";
              //alert(data.data.安平项目[1].num)
              this.selectAllList = data.data;
              // let options = this.search[2].options;
              for (let i=0;i<this.selectAllList.length;i++){
                let projectObj = {};
                projectObj.label = data.data[i].project_id;
                projectObj.value = i;
                this.DvData .push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },

      //获取播放地址
      getVideo:function (){
        if(this.valueID == '' || this.choiceDate == '' || this.choiceTime == ''){
          this.$message.error('请选择搜索条件!');
        }else {
          this.tableData = []
          this.tableDataCopy = []
          fetch("/api/v1/camera/Getvideo", {
            method: 'post',
            body: JSON.stringify({
              "device_num":this.valueID,
              "date":this.choiceDate,
              "time":this.choiceTime,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200" && data.data.length != 0) {
                this.message = "数据获取成功";
                this.totalPage = data.data.length
                for (let i=0;i<data.data.length;i++){
                  let projectObj = {};
                  projectObj.num = this.valueID;
                  projectObj.start_time = data.data[i].start_time;
                  projectObj.end_time = data.data[i].end_time;
                  projectObj.videoUrl = data.data[i].url;
                  this.tableDataCopy.push(projectObj);
                }
                if(this.totalPage <= 4){
                  this.tableData = this.tableDataCopy
                }else {
                  this.nowPage = 1
                  for (let n=0;n<4;n++){
                    let projectObj = {};
                    projectObj.num = this.valueID;
                    projectObj.start_time = this.tableDataCopy[n].start_time;
                    projectObj.end_time = this.tableDataCopy[n].end_time;
                    projectObj.videoUrl = this.tableDataCopy[n].videoUrl;
                    this.tableData.push(projectObj);
                  }

                }
                //this.video_0 = data.data[0]
              }else if(data.code == "200"  && data.data.length == 0){
                this.tableData = []
                this.$message({
                  message: '此时间段没有录像！(日期)',
                  type: 'warning'
                });
              }else {
                this.message = "数据更新异常，请重试";
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
            });
        }
      },

    //下一页
      nextClick:function () {
        this.tableData = []
        this.nowPage = this.nowPage + 1
        let n = (this.nowPage-1)*4
        for (let i=0;i<4;i++){
          let projectObj = {};
          projectObj.num = this.valueID;
          projectObj.start_time = this.tableDataCopy[n].start_time;
          projectObj.end_time = this.tableDataCopy[n].end_time;
          projectObj.videoUrl = this.tableDataCopy[n].videoUrl;
          this.tableData.push(projectObj);
          n++
        }
      },

      //上一页
      prevClick:function () {
        this.tableData = []
        this.nowPage = this.nowPage - 1
        let n = (this.nowPage-1)*4
        for (let i=0;i<4;i++){
          let projectObj = {};
          projectObj.num = this.valueID;
          projectObj.start_time = this.tableDataCopy[n].start_time;
          projectObj.end_time = this.tableDataCopy[n].end_time;
          projectObj.videoUrl = this.tableDataCopy[n].videoUrl;
          this.tableData.push(projectObj);
          n++
        }
      },
      //点击分页
      getPage:function (val) {
        this.tableData = []
        this.nowPage = val
        let n = (this.nowPage-1)*4
        for (let i=0;i<4;i++){
          let projectObj = {};
          projectObj.num = this.valueID;
          projectObj.start_time = this.tableDataCopy[n].start_time;
          projectObj.end_time = this.tableDataCopy[n].end_time;
          projectObj.videoUrl = this.tableDataCopy[n].videoUrl;
          this.tableData.push(projectObj);
          n++
        }
      },

    },
    created(){
      this.InitLeftMenu();
      this.getSelectAll();
    },

    mounted() {
      //this.playerMove1();
      // this.playerMove2();
      // this.playerMove3();
      // this.playerMove4();
      // var player1 = new EZuikit.EZUIPlayer('myPlayer1');
      // var player2 = new EZuikit.EZUIPlayer('myPlayer2');
      // var player3 = new EZuikit.EZUIPlayer('myPlayer3');
      // var player4 = new EZuikit.EZUIPlayer('myPlayer4');
    }
  }
</script>

<style scoped>
  .search_options_box > img{
    top: 23px;
  }
  .video_list {
    width: 100%;
    height: 100%;
  }

  .video_content {
    padding: 20px;
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .video_boxs {
    width: calc(70% - 50px);
    height: calc(100% - 40);
    background: #16518d;
    border-radius: 6px;
    padding: 20px;
  }

  .equipment {
    width: calc(30% - 50px);
    height: calc(100% - 40);
    background: #16518d;
    border-radius: 6px;
    padding: 20px;
  }

  .equipment_title {
    font-size: 18px;
    color: #FFFFFF;
    margin: 10px 0px 0px;
  }

  .table_content {
    width: 100%;
    padding: 20px 0px;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th {
    background-color: #0e345b;
  }

  .table_content > table tr td {
    /*background-color: #16518d;*/
  }

  .table_content > table tr td input {
    width: 16px;
    height: 16px;

  }

  .table_content > table tr:nth-child(2n) {
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 52px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .table_paging {
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #094b8e;
    border-radius: 6px;
    margin-top: 10px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .search {
    width: 100%;
    height: 50px;
    padding: 20px 0px 0px;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .search_options_box {
    width: 25%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_boxs {
    width: 100%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    /*display: flex;*/
    align-items: center;
    justify-content: center;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_boxs > span {
    width: 264px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    right: 20px;
    cursor: pointer;
  }

  .search_options_boxs > select {
    width: calc(100% - 12px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_boxs option {
    color: #000000;
  }

  .search_options_boxs > img {
    position: absolute;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .blue {
    background: #169bd5;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  #date {
    width: calc(100% - 90px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: transparent;
    text-shadow: 0 0 0 #FFFFFF;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #fff;
  }

  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #fff;
  }

  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #fff;
  }

  input::-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #fff;
  }

  .video_play {
    width: 100%;
    height: calc(100% - 40px);
    background: #0e345b;
    margin-top: 20px;
  }

  .video_box {
    width: 100%;
    height: 100%;
    background: #0e345b;
    margin-bottom: 10px;
  }

  /deep/ .el-input__inner {
    padding-left: 30px!important;
  }

  /deep/ .cell {
    font-size: 16px;
  }

  /deep/ .el-table__row {
    height: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/3_protection/video_list.vue